/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Type_CarInputs */

const vi_vehicle_type_car = /** @type {(inputs: Vehicle_Type_CarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ô tô`)
};

/**

* @param {Vehicle_Type_CarInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_type_car = /** @type {((inputs?: Vehicle_Type_CarInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Type_CarInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_type_car(inputs)
});